import { createFileRoute } from "@tanstack/react-router";
import { DEFAULT_COMPANY, isCompanyId } from "../prototype/fixtures";
import { JournalsScreen } from "../screens/JournalsScreen";

export const Route = createFileRoute("/prototype/c/$companyId/journals/")({
  component: Journals,
});

function Journals() {
  const { companyId } = Route.useParams();
  return <JournalsScreen companyId={isCompanyId(companyId) ? companyId : DEFAULT_COMPANY} />;
}
